var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},_vm._l((_vm.list),function(item,i){return _c('div',{key:i},[_c('full-period-io-info-mob-item',{attrs:{"item":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }